module.exports = __webpack_public_path__ + "img/news-2.4949feb3.jpg";